import { render, staticRenderFns } from "./InvoiceMetrics.vue?vue&type=template&id=c1b7fb54&"
import script from "./InvoiceMetrics.vue?vue&type=script&lang=ts&"
export * from "./InvoiceMetrics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports